import { IDaySchedule, IScheduleRange } from '../../models';
import { scheduleRangeInsideOther } from './schedule-range-inside-other';

export function checkPart(defaultSchedule: IDaySchedule, part: IScheduleRange): boolean {
  const hasTwoRanges = !!defaultSchedule.second;

  return hasTwoRanges
    ? scheduleRangeInsideOther(defaultSchedule.first, part) && scheduleRangeInsideOther(defaultSchedule.second, part)
    : scheduleRangeInsideOther(defaultSchedule.first, part);
}
